import styled from '@emotion/styled'
import { ON_CALL_FULLSCREEN_CHAT_WIDTH } from '@oneToOne/shared/components/chat/constants'

export const OnCallChatWrapper = styled.div`
  height: 100%;
  width: ${ON_CALL_FULLSCREEN_CHAT_WIDTH}px;
  background: white;
`
